import { Route, Switch } from 'wouter'

import { HomePage } from '@/features/home'
import { ProductsPage } from '@/features/products'
import { WorkshopPage } from '@/features/workshop'

import NotFoundPage from '@/app/NotFoundPage'

export default function Router() {
  return (
    <Switch>
      <Route path="/workshop">
        <WorkshopPage />
      </Route>

      <Route path="/products">
        <ProductsPage />
      </Route>

      <Route path="/">
        <HomePage />
      </Route>

      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  )
}
